import { SpinnerSize } from "@fluentui/react";
import React, { useState } from "react";
import { ButtonProps, CommandBarButton, Spinner, useNotifications } from "sprint-common-web";

import { useAdminAirlineApi } from "../../common/api/useAdminAirlineApi";

export const SyncAirlinesButton: React.FC<ButtonProps> = (props: ButtonProps) => {
    const [isSyncing, setIsSyncing] = useState<boolean>(false);

    const { syncAirlines } = useAdminAirlineApi();
    const { success } = useNotifications();

    const handleSyncAirlines = () => {
        setIsSyncing(true);

        syncAirlines()
            .then(() => {
                success("Airlines have been synced.");
            })
            .finally(() => {
                setIsSyncing(false);
            });
    };

    return (
        <>
            <CommandBarButton onClick={() => handleSyncAirlines()} text="Sync" icon="SyncFolder" disabled={isSyncing} />
            {isSyncing && <Spinner size={SpinnerSize.xSmall} />}
        </>
    );
};
